const ReceivedBoxes = ({ number }) => (
    <>
        <span className="tag is-white is-size-1 is-hidden-mobile">
            {number} <span className="ml-1 is-size-7">boxes</span>
        </span>

        {/* mobile */}
        <span className="tag is-white is-size-3 is-hidden-tablet">
            {number} <span className="ml-1 is-size-7">boxes</span>
        </span>
    </>
);

const InfoTag = ({ customer }) => (
    <>
        <p className="is-size-5">{customer.full_name}</p>
        <p className="is-size-5"><strong>{customer.age} years old</strong></p>
        <p className="is-size-5">{customer.city}</p>
    </>
);
const DisplayFlag = ({ value, flag }) => {
    if (!value) { return null }

    return (
        <div className="column">
            <p className="is-size-1" id={`flag-${flag}`}>{flag}</p>
        </div>
    )
}

const CustomerInfo = ({ customer, boxes, atRisk, winBack = false }) => (
    <div className="columns is-mobile is-vcentered is-gapless">
        <div className="column">
            <ReceivedBoxes number={boxes.length} />
        </div>
        <DisplayFlag value={atRisk} flag="🚩" />
        <DisplayFlag value={winBack} flag="⭐️" />
        <div className="column">
            <InfoTag customer={customer} />
        </div>
        <div className="column is-6 is-hidden-mobile"></div>
    </div >
);

export { CustomerInfo };
